import React from "react";
import About from "../components/aboutMe";
import Landing from "../components/landing";
import Resume from "../components/resume";

function home() {
  return (
    <div id="home">
        <Landing />
        <About />
        <Resume />
    </div>
  );
}

export default home;
